function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNavMarker = function SvgNavMarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18.49,
    viewBox: "0 0 4.2333 4.8921",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -292.11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.23318 0 0 .23356 1.1859 293.4)",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.1213 6.1213c0.56261-0.56261 0.87868-1.3257 0.87868-2.1213s-0.31607-1.5587-0.87868-2.1213-1.3257-0.87868-2.1213-0.87868-1.5587 0.31607-2.1213 0.87868-0.87868 1.3257-0.87868 2.1213 0.31607 1.5587 0.87868 2.1213 1.3257 0.87868 2.1213 0.87868 1.5587-0.31607 2.1213-0.87868z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#1c2225"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.23318 0 0 .23356 .019997 292.21)",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.657 14.657-4.243 4.243c-0.1856 0.1858-0.4059 0.3331-0.64844 0.4336-0.24253 0.1006-0.50251 0.1523-0.76506 0.1523-0.26254 0-0.52252-0.0517-0.76506-0.1523-0.24253-0.1005-0.46288-0.2478-0.64844-0.4336l-4.244-4.243c-1.1188-1.1188-1.8807-2.5443-2.1893-4.0961-0.30865-1.5519-0.1502-3.1604 0.45532-4.6222 0.60551-1.4618 1.6309-2.7112 2.9465-3.5902 1.3156-0.87903 2.8623-1.3482 4.4445-1.3482 1.5822 0 3.1289 0.46918 4.4445 1.3482s2.341 2.1284 2.9465 3.5902c0.6055 1.4618 0.764 3.0703 0.4553 4.6222-0.3086 1.5518-1.0705 2.9773-2.1893 4.0961z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#1c2225"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav-marker.1364a138.svg";
export { ForwardRef as ReactComponent };